
import React, { useState, useRef } from "react";
import RankingParticipantManager from "./RankingParticipantManager";
import AddQuestionModule from "./AddQuestionModule";
import { UserIcon } from "./icons/UserIcon";
import { PlusCircleIcon } from "./icons/PlusCircleIcon";
import { AnimatePresence, motion } from "framer-motion";

const MODULES = [
  {
    key: "participants",
    title: "Gestión de Participantes",
    icon: <UserIcon className="w-6 h-6" />,
    Component: RankingParticipantManager,
  },
  {
    key: "questions",
    title: "Agregar Pregunta",
    icon: <PlusCircleIcon className="w-6 h-6" />,
    Component: AddQuestionModule,
  },
];

export default function DirectIntroSection() {
  const [openModule, setOpenModule] = useState(null);
  // const [pendingSave, setPendingSave] = useState(null);
  // const formRefs = {
  //   participants: useRef(),
  //   questions: useRef(),
  // };

  // Lógica para guardar el formulario al cerrar
  const handleToggle = (key) => {
    if (openModule === key) {
      setOpenModule(null);
    } else {
      setOpenModule(key);
    }
  };

  return (
    <section className="overflow-x-hidden">
      <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-row sm:gap-4 mb-2">
        {MODULES.map((mod) => (
          <button
              key={mod.key}
              className={`w-full flex items-center gap-2 px-3 sm:px-6 py-3 sm:py-4 rounded-xl sm:rounded-t-2xl border-b-4 transition-all duration-300 font-bold text-xs sm:text-base lg:text-lg justify-center text-center leading-tight
                ${openModule === mod.key
                  ? "bg-black/80 border-primary text-primary shadow-lg"
                  : "bg-black/60 border-transparent text-white hover:text-primary hover:border-primary/60"
                }`}
              type="button"
              aria-expanded={openModule === mod.key}
              onClick={() => handleToggle(mod.key)}
              style={{ position: "relative" }}
            >
              <span className="text-2xl">{mod.icon}</span>
              {mod.title}
              {/* Barra blanca animada */}
              {openModule === mod.key && (
                <motion.div
                  layoutId="tab-underline"
                  className="absolute left-0 right-0 bottom-0 h-1 rounded-b bg-white"
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 8 }}
                  transition={{ type: "spring", stiffness: 400, damping: 30, duration: 0.3 }}
                />
              )}
            </button>
          ))}
        </div>
      <AnimatePresence initial={false} mode="wait">
        {openModule && (
          <motion.div
            key={openModule}
            initial={{ opacity: 0, y: -40, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: 40, height: 0 }}
            transition={{ duration: 0.28, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <motion.div
              initial={{ opacity: 0, y: -24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 24 }}
              transition={{ duration: 0.28, ease: "easeInOut" }}
            >
              {MODULES.map(({ key, Component }) =>
                openModule === key ? (
                  <div key={key} id="module-form">
                    <Component />
                  </div>
                ) : null
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
